import React from "react";

const TemarioDiplomaturaForense = () => {
    return (
        <div className="temario-container border w-100 p-5">
            <b>{"Introducción Y Generalidades"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Introducción"}</span></li>
                <li><span className="fw-light">{"Concepto de Criminalística, Criminología, Medicina Legal, Deontología Médica y Bioética"}</span></li>
                <li><span className="fw-light">{"Historia"}</span></li>
                <li><span className="fw-light">{"Relevancia de las Ciencias Forenses en la investigación criminal"}</span></li>
                <li><span className="fw-light">{"Peritos"}</span></li>
                <li><span className="fw-light">{"Organización de la Justicia"}</span></li>
                <li><span className="fw-light">{"Código Penal"}</span></li>
                <li><span className="fw-light">{"Código Procesal Penal"}</span></li>
                <li><span className="fw-light">{"La Criminalística y el Derecho Penal"}</span></li>
                <li><span className="fw-light">{"Criminología: Nociones básicas"}</span></li>
                <li><span className="fw-light">{"Estudio de los delitos más comunes y su investigación científica"}</span></li>
                <li><span className="fw-light">{"Laboratorios de investigación criminal"}</span></li>
            </ul>
            <br /><br />
            <b>{"El Lugar Del Hecho"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Investigación médico-legal del lugar del Hecho"}</span></li>
                <li><span className="fw-light">{"Investigación criminalística del lugar del hecho o del hallazgo"}</span></li>
                <li><span className="fw-light">{"Aspectos periciales"}</span></li>
                <li><span className="fw-light">{"Levantamiento de rastros"}</span></li>
                <li><span className="fw-light">{"Evidencias"}</span></li>
                <li><span className="fw-light">{"Pruebas científicas en el lugar del hecho"}</span></li>
                <li><span className="fw-light">{"Guía de procedimientos para la escena del crimen"}</span></li>
                <li><span className="fw-light">{"Tratamiento particular de diversos tipos de evidencia física"}</span></li>
                <li><span className="fw-light">{"Cadena de custodia"}</span></li>
                <li><span className="fw-light">{"Detección de Pólvora y Levantamiento de Evidencias"}</span></li>
            </ul>
            <br /><br />
            <b>{"Tanatología"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Tanatología general: la autopsia médico-legal"}</span></li>
                <li><span className="fw-light">{"Tipos de autopsia"}</span></li>
                <li><span className="fw-light">{"Procedimientos relacionados"}</span></li>
                <li><span className="fw-light">{"Tanatosemiología y tanatocronodiagnóstico"}</span></li>
                <li><span className="fw-light">{"Determinación del intervalo postmortal"}</span></li>
            </ul>
            <br /><br />
            <b>{"Toxicología Forense"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Toxicología Forense"}</span></li>
                <li><span className="fw-light">{"Tipo y toma de muestras en pacientes y cadáveres"}</span></li>
                <li><span className="fw-light">{"Analítica"}</span></li>
                <li><span className="fw-light">{"Tipos de tóxicos, clasificación"}</span></li>
                <li><span className="fw-light">{"Drogas de abuso y sustancias psicoactivas"}</span></li>
                <li><span className="fw-light">{"Sumisión química"}</span></li>
                <li><span className="fw-light">{"Delitos facilitados por drogas"}</span></li>
                <li><span className="fw-light">{"Intoxicaciones más frecuentes en la práctica forense"}</span></li>
                <li><span className="fw-light">{"Intoxicación suicida, homicida y accidental"}</span></li>
            </ul>
            <br /><br />
            <b>{"Papiloscopía Y Necropapiloscopia"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Introducción a la papiloscopía y sistemas de identificación"}</span></li>
                <li><span className="fw-light">{"Técnicas de papiloscopía; avances en la materia"}</span></li>
                <li><span className="fw-light">{"Levantamiento de muestras papiloscópicas y rastros"}</span></li>
                <li><span className="fw-light">{"Revelado de Huellas Dactilares y de Pisadas"}</span></li>
                <li><span className="fw-light">{"Técnicas especiales"}</span></li>
                <li><span className="fw-light">{"Necropapiloscopía"}</span></li>
                <li><span className="fw-light">{"Técnicas especiales de recolección de muestras papiloscópicas"}</span></li>
            </ul>
            <br /><br />
            <b>{"Genética Y Bioquímica Forense"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Introducción a la genética forense"}</span></li>
                <li><span className="fw-light">{"Biología molecular"}</span></li>
                <li><span className="fw-light">{"Tipos de muestras"}</span></li>
                <li><span className="fw-light">{"Recolección de muestras"}</span></li>
                <li><span className="fw-light">{"Análisis genéticos"}</span></li>
                <li><span className="fw-light">{"Filiación"}</span></li>
                <li><span className="fw-light">{"Importancia de la química en la práctica forense"}</span></li>
                <li><span className="fw-light">{"Muestras de sangre, humor vítreo, secreciones y fluidos corporales"}</span></li>
                <li><span className="fw-light">{"Valor pericial de los hallazgos"}</span></li>
                <li><span className="fw-light">{"Análisis de manchas"}</span></li>
            </ul>
            <br /><br />
            <b>{"Patología Forense General"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Introducción a la patología forense general"}</span></li>
                <li><span className="fw-light">{"Patología forense de la injuria traumática: contusiones simples y complejas"}</span></li>
                <li><span className="fw-light">{"Cuestiones periciales"}</span></li>
                <li><span className="fw-light">{"Patología forense de las lesiones por armas blancas"}</span></li>
                <li><span className="fw-light">{"Cuestiones periciales"}</span></li>
                <li><span className="fw-light">{"Patología forense de las lesiones por injuria térmica, cáusticos y electricidad"}</span></li>
                <li><span className="fw-light">{"Cuestiones periciales"}</span></li>
                <li><span className="fw-light">{"Radiología Forense"}</span></li>
                <li><span className="fw-light">{"Radiología forense aplicada a las lesiones"}</span></li>
                <li><span className="fw-light">{"Radiología forense en la sala de autopsias"}</span></li>
                <li><span className="fw-light">{"Radiología forense en situaciones especiales: Protocolos de Estambul y Minnesota"}</span></li>
                <li><span className="fw-light">{"Femicidios"}</span></li>
                <li><span className="fw-light">{"Maltrato infantil"}</span></li>
                <li><span className="fw-light">{"Patología forense de las lesiones por proyectiles de armas de fuego"}</span></li>
                <li><span className="fw-light">{"Cuestiones periciales"}</span></li>
                <li><span className="fw-light">{"Patología forense de las asfixias"}</span></li>
                <li><span className="fw-light">{"Generalidades"}</span></li>
                <li><span className="fw-light">{"Tipos y clasificación"}</span></li>
                <li><span className="fw-light">{"Asfixias mecánicas"}</span></li>
                <li><span className="fw-light">{"Cuestiones periciales y criminalísticas"}</span></li>
                <li><span className="fw-light">{"El lugar del hecho"}</span></li>
            </ul>
            <br /><br />
            <b>{"Patología Forense Especial"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Patología forense en el maltrato infantil"}</span></li>
                <li><span className="fw-light">{"La muerte perinatal"}</span></li>
                <li><span className="fw-light">{"Cuestiones periciales y criminalísticas"}</span></li>
                <li><span className="fw-light">{"Femicidios"}</span></li>
                <li><span className="fw-light">{"Protocolos especiales: Protocolo de Minnesota"}</span></li>
                <li><span className="fw-light">{"Cadáveres carbonizados"}</span></li>
                <li><span className="fw-light">{"Grandes quemados"}</span></li>
                <li><span className="fw-light">{"Muertes por responsabilidad profesional"}</span></li>
            </ul>
            <br /><br />
            <b>{"Fotografía Pericial"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"La fotografía forense"}</span></li>
                <li><span className="fw-light">{"Aspectos criminalísticos, periciales y médico-legales"}</span></li>
                <li><span className="fw-light">{"Registros en video"}</span></li>
                <li><span className="fw-light">{"Otras formas de registro"}</span></li>
                <li><span className="fw-light">{"Planimetría"}</span></li>
                <li><span className="fw-light">{"Uso de herramientas informáticas en la documentación de las prácticas periciales"}</span></li>
            </ul>
            <br /><br />
            <b>{"Antropología Forense"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Antropología Forense"}</span></li>
                <li><span className="fw-light">{"Cuestiones periciales"}</span></li>
                <li><span className="fw-light">{"Estudios radiológicos: aspectos forenses, criminalísticos y médico-legales"}</span></li>
                <li><span className="fw-light">{"Exhumación médicolegal"}</span></li>
                <li><span className="fw-light">{"Nociones básicas periciales"}</span></li>
                <li><span className="fw-light">{"Autopsia médico legal y examen antropológico en caso de exhumaciones"}</span></li>
            </ul>
            <br /><br />
            <b>{"Salud Mental Y Sexología Forense"}</b>
            <br /><br />
            <ul>
                <li><span className="fw-light">{"Psicología forense"}</span></li>
                <li><span className="fw-light">{"La pericia psicológica"}</span></li>
                <li><span className="fw-light">{"Aspectos éticos y periciales"}</span></li>
                <li><span className="fw-light">{"La integración de los procesos de salud mental a las ciencias forenses"}</span></li>
                <li><span className="fw-light">{"Delitos contra la integridad sexual"}</span></li>
                <li><span className="fw-light">{"Investigación en casos fatales y no fatales"}</span></li>
                <li><span className="fw-light">{"Toma de muestras"}</span></li>
                <li><span className="fw-light">{"Protocolos de acción"}</span></li>
                <li><span className="fw-light">{"Aborto, ILE, IVE"}</span></li>
                <li><span className="fw-light">{"Cuestiones periciales y criminalísticas"}</span></li>
            </ul>
        </div>
    );
};

export default TemarioDiplomaturaForense;